import React from "react";
import contextProvider from "../../contextProvider";
import { withRouter, Link } from "react-router-dom";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";

class RowSpanTableDiag extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      data: {},
      _collapse_controllers: {},
      sortAsc: true,
      sortAscB: true,
    };
    super(props, initState);
  }

  /////////////////////////
  //	Lifecycle methods

  onComponentDidMount() {
    this.apiStore = this.getAppContext().getApiStoreService();
  }

  onComponentWillUnmount() {}

  customSort(col) {
    if (this.state.sortAsc == true) {
      return col.sort();
    } else {
      return col.reverse();
    }
  }

  customSortB(col) {
    if (this.state.sortAscB == true) {
      return col.sort();
    } else {
      return col.reverse();
    }
  }

  onRender() {
    return (
      <div>
        <div className="d-flex">
          <div className="flex-grow-1 table-responsive-xl">
            <table className="table">
              {this.getAppContext().media.isMobile ? null : (
                <thead className="thead-light">
                  <tr>
                    {this.props.cols.map((_th, id) => {
                      return (
                        <th
                          key={_th.data_key}
                          scope="col"
                          className={
                            id == 0
                              ? "cursor-col-table text-nowrap text-muted dividers px-2 py-1"
                              : "text-nowrap text-muted dividers px-2 py-1"
                          }
                          style={
                            id == 0
                              ? { width: _th.width + "%", cursor: "pointer" }
                              : { width: _th.width + "%" }
                          }
                          {...(id == 0
                            ? {
                                onClick: () => {
                                  this.setState({
                                    sortAsc: !this.state.sortAsc,
                                  });
                                },
                              }
                            : // : id == 2
                              // ? {
                              //     onClick: () => {
                              //       console.log("click");
                              //       this.setState({
                              //         sortAscB: !this.state.sortAscB,
                              //       });
                              //     },
                              //   }
                              {})}
                        >
                          <div
                            className={"d-flex justify-content-" + _th.align}
                          >
                            <small className="">
                              <strong>
                                {_th.title}
                                <span
                                  className={
                                    id == 0
                                      ? this.state.sortAsc == true
                                        ? "text-nowrap sorting-caret icon-caret-up"
                                        : "text-nowrap sorting-caret icon-caret-down"
                                      : null
                                  }
                                />
                              </strong>
                            </small>
                          </div>
                        </th>
                      );
                    })}
                  </tr>
                </thead>
              )}
              {this.props.renderKey == "probe" ? (
                this.getAppContext().media.isMobile ? (
                  <tbody>
                    {(() => {
                      let k = 0;
                      return Object.keys(this.props.data)
                        .sort()
                        .map((probename, id) => {
                          return Object.keys(this.props.data[probename]).map(
                            (essid, id2) => {
                              return this.props.data[probename][essid].map(
                                (row, id3) => {
                                  k += 1;
                                  return (
                                    <tr
                                      key={id3}
                                      className={
                                        k % 2 == 0
                                          ? "row-stripe-table p-2"
                                          : "p-2"
                                      }
                                    >
                                      <td>
                                        <div className="p-1">
                                          <Link
                                            to={"/" + row.probeid + "/active/"}
                                            target="_blank"
                                          >
                                            <div>
                                              <strong> {probename}</strong>
                                            </div>
                                            <div className="sub-title">
                                              {" "}
                                              {row.probeid
                                                .replace(/(..)/g, "$1:")
                                                .slice(0, -1)}{" "}
                                            </div>
                                          </Link>
                                        </div>
                                        <div className="p-1">
                                          <div>
                                            <div>
                                              <strong className="sub-title">
                                                ESSID:{" "}
                                              </strong>
                                            </div>
                                            <strong>{essid}</strong>
                                          </div>
                                          <div className="sub-title">
                                            {row.name
                                              .replace(/\s+/g, " ")
                                              .trim() ==
                                            row.essid + " with test " + row.test
                                              ? row.test
                                              : row.name}
                                          </div>
                                        </div>
                                        <div className="p-1">
                                          <div>
                                            <strong className="sub-title">
                                              AP:{" "}
                                            </strong>
                                          </div>
                                          {row.ap_name != "-" &&
                                          row.ap_name != row.bssid ? (
                                            <div>
                                              <strong>{row.ap_name}</strong>
                                            </div>
                                          ) : (
                                            <div>
                                              <strong>{row.bssid}</strong>{" "}
                                            </div>
                                          )}
                                          {row.ap_name != "-" &&
                                          row.ap_name != row.bssid ? (
                                            <span className="sub-title">
                                              {row.bssid}{" "}
                                            </span>
                                          ) : row.manuf ? (
                                            <span className="sub-title">
                                              {row.manuf}{" "}
                                            </span>
                                          ) : null}
                                        </div>
                                        <div className="p-1">
                                          <Link
                                            to={
                                              "/" +
                                              row.probeid +
                                              "/active/" +
                                              row.cssid +
                                              "/" +
                                              row.bssid.replace(/:/g, "")
                                            }
                                            target="_blank"
                                          >
                                            <div>
                                              <strong className="sub-title">
                                                STATUS:{" "}
                                              </strong>
                                            </div>
                                            <span
                                              className={
                                                row.last_state == "N" ||
                                                row.last_state == "U"
                                                  ? "text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      row.last_state
                                                    ].color
                                                  : "text-" + row.color
                                              }
                                            >
                                              cr
                                            </span>
                                            {row.err_step ? (
                                              <div
                                                className={
                                                  row.last_state == "N" ||
                                                  row.last_state == "U"
                                                    ? "text-" +
                                                      this.getAppContext().conf
                                                        .MLY_STATES_DICTIONARY[
                                                        row.last_state
                                                      ].color
                                                    : "text-" + row.color
                                                }
                                              >
                                                {row.err_step &&
                                                row.err_step.length > 0
                                                  ? row.err_step.substring(
                                                      0,
                                                      2
                                                    ) == "MO"
                                                    ? "mostly on " +
                                                      row.err_step.substring(
                                                        3,
                                                        row.err_step.length
                                                      )
                                                    : "on " +
                                                      row.err_step.substring(
                                                        3,
                                                        row.err_step.length
                                                      )
                                                  : null}
                                              </div>
                                            ) : null}
                                          </Link>
                                        </div>
                                        {/* <div className="p-1">
                                <div>
                                  <strong className="sub-title">SINCE: </strong>
                                </div>
                                {this.getAppContext()
                                  .momentjs(row.since, "X")
                                  .format("YYYY") < 2014 ? (
                                  "-"
                                ) : (
                                  <div>
                                    <div>
                                      {this.getAppContext()
                                        .momentjs(row.since, "X")
                                        .format("DD-MM-YYYY")}
                                    </div>
                                    <div className="sub-title">
                                      {this.getAppContext()
                                        .momentjs(row.since, "X")
                                        .format("HH:mm")}
                                    </div>
                                  </div>
                                )}
                              </div> */}
                                      </td>
                                    </tr>
                                  );
                                }
                              );
                            }
                          );
                        });
                    })()}
                  </tbody>
                ) : (
                  <tbody>
                    {this.customSort(Object.keys(this.props.data)).map(
                      (probename, id) =>
                        Object.keys(this.props.data[probename]).map(
                          (essid, id2) =>
                            this.props.data[probename][essid].map(
                              (row, id3) => {
                                // console.log(row);
                                return (
                                  <tr
                                    key={id3}
                                    className={
                                      id % 2 != 0 ? "row-stripe-table" : ""
                                    }
                                  >
                                    {id2 == 0 && id3 == 0 ? (
                                      <td
                                        rowSpan={
                                          this.props.rowSpan.probe[probename]
                                        }
                                        className="border-right align-middle text-center"
                                        title={`View active measures for ${probename}`}
                                      >
                                        <Link
                                          to={"/" + row.probeid + "/active/"}
                                          target="_blank"
                                        >
                                          <div>
                                            <strong> {probename} </strong>
                                            <div className="sub-title">
                                              {" "}
                                              {row.probeid
                                                .replace(/(..)/g, "$1:")
                                                .slice(0, -1)}{" "}
                                            </div>
                                          </div>
                                        </Link>
                                      </td>
                                    ) : null}
                                    {id3 == 0 ? (
                                      <td
                                        rowSpan={
                                          this.props.data[probename][essid]
                                            .length
                                        }
                                        className="border-right align-middle text-center"
                                        title={`View details for ${
                                          row.test || essid
                                        }`}
                                      >
                                        <Link
                                          to={
                                            "/" +
                                            row.probeid +
                                            "/active/" +
                                            row.cssid
                                          }
                                          target="_blank"
                                        >
                                          <div>
                                            <div>
                                              <strong>{essid}</strong>
                                            </div>
                                            <div className="sub-title">
                                              {row.name
                                                .replace(/\s+/g, " ")
                                                .trim() ==
                                              row.essid +
                                                " with test " +
                                                row.test
                                                ? row.test
                                                : row.name}
                                            </div>
                                          </div>
                                        </Link>
                                      </td>
                                    ) : null}
                                    <td
                                      className="border-right align-middle text-center"
                                      title={`View measure details for ${
                                        row.ap_name && row.ap_name != "-"
                                          ? row.ap_name
                                          : row.bssid
                                      }`}
                                    >
                                      <Link
                                        to={
                                          "/" +
                                          row.probeid +
                                          "/active/" +
                                          row.cssid +
                                          "/" +
                                          row.bssid.replace(/:/g, "")
                                        }
                                        target="_blank"
                                      >
                                        <div>
                                          {row.ap_name != "-" &&
                                          row.ap_name != row.bssid ? (
                                            <div>
                                              <strong>{row.ap_name}</strong>
                                            </div>
                                          ) : (
                                            <div>
                                              <strong>{row.bssid}</strong>{" "}
                                            </div>
                                          )}
                                          {row.ap_name != "-" &&
                                          row.ap_name != row.bssid ? (
                                            <span className="sub-title">
                                              {row.bssid}{" "}
                                            </span>
                                          ) : row.manuf ? (
                                            <span className="sub-title">
                                              {row.manuf}{" "}
                                            </span>
                                          ) : null}
                                        </div>
                                      </Link>
                                    </td>
                                    <td
                                      className="border-right align-middle text-center"
                                      title={`View measure details for ${
                                        row.ap_name && row.ap_name != "-"
                                          ? row.ap_name
                                          : row.bssid
                                      }`}
                                    >
                                      <Link
                                        to={
                                          "/" +
                                          row.probeid +
                                          "/active/" +
                                          row.cssid +
                                          "/" +
                                          row.bssid.replace(/:/g, "")
                                        }
                                        target="_blank"
                                      >
                                        <div>
                                          <span
                                            className={
                                              row.last_state == "N" ||
                                              row.last_state == "U"
                                                ? "text-" +
                                                  this.getAppContext().conf
                                                    .MLY_STATES_DICTIONARY[
                                                    row.last_state
                                                  ].color
                                                : "text-" + row.color
                                            }
                                          >
                                            {
                                              // this.getAppContext().conf.MLY_STATES_DICTIONARY[
                                              //   row.diag
                                              // ].text
                                              this.getAppContext().getDiag(
                                                row.diag,
                                                row.consideration
                                              )
                                            }
                                          </span>
                                          {row.err_step ? (
                                            <div
                                              className={
                                                row.last_state == "N" ||
                                                row.last_state == "U"
                                                  ? "text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      row.last_state
                                                    ].color
                                                  : "text-" + row.color
                                              }
                                            >
                                              {row.err_step &&
                                              row.err_step.length > 0
                                                ? row.err_step.substring(
                                                    0,
                                                    2
                                                  ) == "MO"
                                                  ? "mostly on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                  : "on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                : null}
                                            </div>
                                          ) : null}
                                        </div>
                                      </Link>
                                    </td>
                                    <td
                                      className="border-right align-middle text-center"
                                      title={`View measure details for ${
                                        row.ap_name && row.ap_name != "-"
                                          ? row.ap_name
                                          : row.bssid
                                      }`}
                                    >
                                      <Link
                                        to={
                                          "/" +
                                          row.probeid +
                                          "/active/" +
                                          row.cssid +
                                          "/" +
                                          row.bssid.replace(/:/g, "")
                                        }
                                        target="_blank"
                                      >
                                        <div>
                                          {this.getAppContext()
                                            .momentjs(row.since, "X")
                                            .format("YYYY") < 2014 ? (
                                            "-"
                                          ) : (
                                            <div>
                                              <div>
                                                {this.getAppContext()
                                                  .momentjs(row.since, "X")
                                                  .format("DD-MM-YYYY")}
                                              </div>
                                              <div className="sub-title">
                                                {this.getAppContext()
                                                  .momentjs(row.since, "X")
                                                  .format("HH:mm")}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              }
                            )
                        )
                    )}
                  </tbody>
                )
              ) : null}

              {this.props.renderKey == "probe_net" ? (
                this.getAppContext().media.isMobile ? (
                  <tbody>
                    {(() => {
                      let k = 0;
                      return Object.keys(this.props.data)
                        .sort()
                        .map((probename, id) => {
                          return Object.keys(this.props.data[probename]).map(
                            (essid, id2) => {
                              return this.props.data[probename][essid].map(
                                (row, id3) => {
                                  k += 1;
                                  return (
                                    <tr
                                      key={id3}
                                      className={
                                        k % 2 == 0
                                          ? "row-stripe-table p-2"
                                          : "p-2"
                                      }
                                    >
                                      <td>
                                        <Link
                                          to={"/" + row.probeid + "/active/"}
                                          target="_blank"
                                        >
                                          <div className="p-1">
                                            <div>
                                              <strong> {probename}</strong>
                                            </div>
                                            <div className="sub-title">
                                              {" "}
                                              {row.probeid
                                                .replace(/(..)/g, "$1:")
                                                .slice(0, -1)}{" "}
                                            </div>
                                          </div>
                                        </Link>
                                        <div className="p-1">
                                          <div>
                                            <div>
                                              <strong className="sub-title">
                                                ESSID:{" "}
                                              </strong>
                                            </div>
                                            <strong>{essid}</strong>
                                          </div>
                                          <div className="sub-title">
                                            {row.name
                                              .replace(/\s+/g, " ")
                                              .trim() ==
                                            row.essid + " with test " + row.test
                                              ? row.test
                                              : row.name}
                                          </div>
                                        </div>
                                        <div className="p-1">
                                          <div>
                                            <strong className="sub-title">
                                              AP:{" "}
                                            </strong>
                                          </div>
                                          {row.ap_name != "-" &&
                                          row.ap_name != row.bssid ? (
                                            <div>
                                              <strong>{row.ap_name}</strong>
                                            </div>
                                          ) : (
                                            <div>
                                              <strong>{row.bssid}</strong>{" "}
                                            </div>
                                          )}
                                          {row.ap_name != "-" &&
                                          row.ap_name != row.bssid ? (
                                            <span className="sub-title">
                                              {row.bssid}{" "}
                                            </span>
                                          ) : row.manuf ? (
                                            <span className="sub-title">
                                              {row.manuf}{" "}
                                            </span>
                                          ) : null}
                                        </div>
                                        <div className="p-1">
                                          <Link
                                            to={
                                              "/" +
                                              row.probeid +
                                              "/active/" +
                                              row.cssid +
                                              "/" +
                                              row.bssid.replace(/:/g, "")
                                            }
                                            target="_blank"
                                          >
                                            <div>
                                              <strong className="sub-title">
                                                STATUS:{" "}
                                              </strong>
                                            </div>
                                            <span
                                              className={
                                                row.last_state == "N" ||
                                                row.last_state == "U"
                                                  ? "text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      row.last_state
                                                    ].color
                                                  : "text-" + row.color
                                              }
                                            >
                                              {
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY[
                                                  row.diag
                                                ].text
                                              }
                                            </span>
                                            {row.err_step ? (
                                              <div
                                                className={
                                                  row.last_state == "N" ||
                                                  row.last_state == "U"
                                                    ? "text-" +
                                                      this.getAppContext().conf
                                                        .MLY_STATES_DICTIONARY[
                                                        row.last_state
                                                      ].color
                                                    : "text-" + row.color
                                                }
                                              >
                                                {row.err_step &&
                                                row.err_step.length > 0
                                                  ? row.err_step.substring(
                                                      0,
                                                      2
                                                    ) == "MO"
                                                    ? "mostly on " +
                                                      row.err_step.substring(
                                                        3,
                                                        row.err_step.length
                                                      )
                                                    : "on " +
                                                      row.err_step.substring(
                                                        3,
                                                        row.err_step.length
                                                      )
                                                  : null}
                                              </div>
                                            ) : null}
                                          </Link>
                                        </div>
                                        {/* <div className="p-1">
                                <div>
                                  <strong className="sub-title">SINCE: </strong>
                                </div>
                                {this.getAppContext()
                                  .momentjs(row.since, "X")
                                  .format("YYYY") < 2014 ? (
                                  "-"
                                ) : (
                                  <div>
                                    <div>
                                      {this.getAppContext()
                                        .momentjs(row.since, "X")
                                        .format("DD-MM-YYYY")}
                                    </div>
                                    <div className="sub-title">
                                      {this.getAppContext()
                                        .momentjs(row.since, "X")
                                        .format("HH:mm")}
                                    </div>
                                  </div>
                                )}
                              </div> */}
                                      </td>
                                    </tr>
                                  );
                                }
                              );
                            }
                          );
                        });
                    })()}
                  </tbody>
                ) : (
                  <tbody>
                    {this.customSort(Object.keys(this.props.data)).map(
                      (probename, id) =>
                        Object.keys(this.props.data[probename]).map(
                          (measureName, id2) =>
                            this.props.data[probename][measureName].map(
                              (row, id3) => {
                                return (
                                  <tr
                                    key={id3}
                                    className={
                                      id % 2 != 0 ? "row-stripe-table" : ""
                                    }
                                  >
                                    {id2 == 0 && id3 == 0 ? (
                                      <td
                                        rowSpan={
                                          this.props.rowSpan.probe[probename]
                                        }
                                        className="border-right align-middle text-center"
                                        title={`View active measures for ${probename}`}
                                      >
                                        <Link
                                          to={"/" + row.probeid + "/active/"}
                                          target="_blank"
                                        >
                                          <div>
                                            <strong> {probename} </strong>
                                            <div className="sub-title">
                                              {" "}
                                              {row.probeid
                                                .replace(/(..)/g, "$1:")
                                                .slice(0, -1)}{" "}
                                            </div>
                                          </div>
                                        </Link>
                                      </td>
                                    ) : null}
                                    {id3 == 0 ? (
                                      <td
                                        rowSpan={
                                          this.props.data[probename][
                                            measureName
                                          ].length
                                        }
                                        className="border-right align-middle text-center"
                                        title={`View details for ${row.name}`}
                                      >
                                        <div>
                                          <Link
                                            to={
                                              "/" +
                                              row.probeid +
                                              "/active/" +
                                              row.cssid +
                                              "/" +
                                              (row.bssid != "-"
                                                ? row.bssid.replace(/:/g, "")
                                                : "overal")
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <strong>{row.name}</strong>
                                          </Link>
                                        </div>
                                      </td>
                                    ) : null}
                                    <td className="border-right align-middle text-center">
                                      <div>
                                        {row.test ? (
                                          <Link
                                            to={"/" + row.probeid + "/active/"}
                                            target="_blank"
                                          >
                                            <strong>{row.test}</strong>
                                          </Link>
                                        ) : (
                                          "-"
                                        )}
                                      </div>
                                    </td>
                                    <td className="border-right align-middle text-center">
                                      <Link
                                        to={
                                          "/" +
                                          row.probeid +
                                          "/active/" +
                                          row.cssid +
                                          "/overal"
                                          // row.bssid.replace(/:/g, "")
                                        }
                                        target="_blank"
                                      >
                                        <div>
                                          <span
                                            className={
                                              row.last_state == "N" ||
                                              row.last_state == "U"
                                                ? "text-" +
                                                  this.getAppContext().conf
                                                    .MLY_STATES_DICTIONARY[
                                                    row.last_state
                                                  ].color
                                                : "text-" + row.color
                                            }
                                          >
                                            {
                                              this.getAppContext().conf
                                                .MLY_STATES_DICTIONARY[row.diag]
                                                .text
                                            }
                                          </span>
                                          {row.err_step ? (
                                            <div
                                              className={
                                                row.last_state == "N" ||
                                                row.last_state == "U"
                                                  ? "text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      row.last_state
                                                    ].color
                                                  : "text-" + row.color
                                              }
                                            >
                                              {row.err_step &&
                                              row.err_step.length > 0
                                                ? row.err_step.substring(
                                                    0,
                                                    2
                                                  ) == "MO"
                                                  ? "mostly on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                  : "on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                : null}
                                            </div>
                                          ) : null}
                                        </div>
                                      </Link>
                                    </td>
                                    <td
                                      className="border-right align-middle text-center"
                                      title={`View measure details for ${
                                        row.ap_name && row.ap_name != "-"
                                          ? row.ap_name
                                          : row.bssid
                                      }`}
                                    >
                                      <Link
                                        to={
                                          "/" +
                                          row.probeid +
                                          "/active/" +
                                          row.cssid +
                                          "/overal"
                                        }
                                        target="_blank"
                                      >
                                        <div>
                                          {this.getAppContext()
                                            .momentjs(row.since, "X")
                                            .format("YYYY") < 2014 ? (
                                            "-"
                                          ) : (
                                            <div>
                                              <div>
                                                {this.getAppContext()
                                                  .momentjs(row.since, "X")
                                                  .format("DD-MM-YYYY")}
                                              </div>
                                              <div className="sub-title">
                                                {this.getAppContext()
                                                  .momentjs(row.since, "X")
                                                  .format("HH:mm")}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              }
                            )
                        )
                    )}
                  </tbody>
                )
              ) : null}

              {this.props.renderKey == "essid" ? (
                this.getAppContext().media.isMobile ? (
                  <tbody>
                    {(() => {
                      let k = 0;
                      return Object.keys(this.props.data)
                        .sort()
                        .map((essid, id) => {
                          return Object.keys(this.props.data[essid]).map(
                            (probename, id2) => {
                              return this.props.data[essid][probename].map(
                                (row, id3) => {
                                  k += 1;
                                  return (
                                    <tr
                                      key={id3}
                                      className={
                                        k % 2 == 0
                                          ? "row-stripe-table p-2"
                                          : "p-2"
                                      }
                                    >
                                      <td>
                                        <div className="p-1">
                                          <div>
                                            {/* <div>
                                        <strong className="sub-title">ESSID: </strong>
                                      </div> */}
                                            <strong>{essid}</strong>
                                          </div>
                                          <div className="sub-title">
                                            {row.name
                                              .replace(/\s+/g, " ")
                                              .trim() ==
                                            row.essid + " with test " + row.test
                                              ? row.test
                                              : row.name}
                                          </div>
                                        </div>
                                        <div className="p-1">
                                          <Link
                                            to={"/" + row.probeid + "/active"}
                                            target="_blank"
                                          >
                                            <div>
                                              <strong className="sub-title">
                                                PROBE:{" "}
                                              </strong>
                                            </div>
                                            <strong> {probename} </strong>
                                            <div className="sub-title">
                                              {" "}
                                              {row.probeid
                                                .replace(/(..)/g, "$1:")
                                                .slice(0, -1)}{" "}
                                            </div>
                                          </Link>
                                        </div>
                                        <div className="p-1">
                                          <Link
                                            to={"/" + row.probeid + "/active/"}
                                            target="_blank"
                                          >
                                            <div>
                                              <strong className="sub-title">
                                                AP:{" "}
                                              </strong>
                                            </div>
                                            {row.ap_name != "-" &&
                                            row.ap_name != row.bssid ? (
                                              <div>
                                                <strong>{row.ap_name}</strong>
                                              </div>
                                            ) : (
                                              <div>
                                                <strong>{row.bssid}</strong>{" "}
                                              </div>
                                            )}
                                            {row.ap_name != "-" &&
                                            row.ap_name != row.bssid ? (
                                              <span className="sub-title">
                                                {row.bssid}{" "}
                                              </span>
                                            ) : row.manuf ? (
                                              <span className="sub-title">
                                                {row.manuf}{" "}
                                              </span>
                                            ) : null}
                                          </Link>
                                        </div>

                                        <div className="p-1">
                                          <div>
                                            <strong className="sub-title">
                                              STATUS:{" "}
                                            </strong>
                                          </div>
                                          <span
                                            className={
                                              row.last_state == "N" ||
                                              row.last_state == "U"
                                                ? "text-" +
                                                  this.getAppContext().conf
                                                    .MLY_STATES_DICTIONARY[
                                                    row.last_state
                                                  ].color
                                                : "text-" + row.color
                                            }
                                          >
                                            {
                                              this.getAppContext().conf
                                                .MLY_STATES_DICTIONARY[row.diag]
                                                .text
                                            }
                                          </span>
                                          {row.err_step ? (
                                            <div
                                              className={
                                                row.last_state == "N" ||
                                                row.last_state == "U"
                                                  ? "text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      row.last_state
                                                    ].color
                                                  : "text-" + row.color
                                              }
                                            >
                                              {row.err_step &&
                                              row.err_step.length > 0
                                                ? row.err_step.substring(
                                                    0,
                                                    2
                                                  ) == "MO"
                                                  ? "mostly on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                  : "on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                : null}
                                            </div>
                                          ) : null}
                                        </div>
                                        {/* <div className="p-1">
                                    <div>
                                      <strong className="sub-title">SINCE: </strong>
                                    </div>
                                    {this.getAppContext()
                                      .momentjs(row.since, "X")
                                      .format("YYYY") < 2014 ? (
                                      "-"
                                    ) : (
                                      <div>
                                        <div>
                                          {this.getAppContext()
                                            .momentjs(row.since, "X")
                                            .format("DD-MM-YYYY")}
                                        </div>
                                        <div className="sub-title">
                                          {this.getAppContext()
                                            .momentjs(row.since, "X")
                                            .format("HH:mm")}
                                        </div>
                                      </div>
                                    )}
                                  </div> */}
                                      </td>
                                    </tr>
                                  );
                                }
                              );
                            }
                          );
                        });
                    })()}
                  </tbody>
                ) : (
                  <tbody>
                    {this.customSort(Object.keys(this.props.data)).map(
                      (essid, id) => {
                        let k = 0;
                        return Object.keys(this.props.data[essid]).map(
                          (probename, id2) => {
                            return this.props.data[essid][probename].map(
                              (row, id3) => {
                                k += 1;
                                return (
                                  <tr
                                    key={id3}
                                    className={
                                      id % 2 != 0 ? "row-stripe-table" : ""
                                    }
                                  >
                                    {/* dynamic */}

                                    {this.props.rowSpan.essid[essid] < 14 ? (
                                      id2 == 0 && id3 == 0 ? (
                                        <td
                                          rowSpan={
                                            this.props.rowSpan.essid[essid]
                                          }
                                          className="border-right align-middle text-center"
                                          title={`View details for ${
                                            row.test || essid
                                          }`}
                                        >
                                          <Link
                                            to={
                                              "/" +
                                              row.probeid +
                                              "/active/" +
                                              row.cssid
                                            }
                                            target="_blank"
                                          >
                                            <div>
                                              <div>
                                                <strong>{essid}</strong>
                                              </div>
                                              <div className="sub-title">
                                                {row.name
                                                  .replace(/\s+/g, " ")
                                                  .trim() ==
                                                row.essid +
                                                  " with test " +
                                                  row.test
                                                  ? row.test
                                                  : row.name}
                                              </div>
                                            </div>
                                          </Link>
                                        </td>
                                      ) : null
                                    ) : id2 == 0 && id3 == 0 ? (
                                      <td
                                        // rowSpan={this.props.rowSpan.essid[essid]}
                                        className="border-right align-middle text-center"
                                        title={`View details for ${
                                          row.test || essid
                                        }`}
                                      >
                                        <Link
                                          to={
                                            "/" +
                                            row.probeid +
                                            "/active/" +
                                            row.cssid
                                          }
                                          target="_blank"
                                        >
                                          <div>
                                            <div>
                                              <strong>{essid}</strong>
                                            </div>
                                            <div className="sub-title">
                                              {row.name
                                                .replace(/\s+/g, " ")
                                                .trim() ==
                                              row.essid +
                                                " with test " +
                                                row.test
                                                ? row.test
                                                : row.name}
                                            </div>
                                          </div>
                                        </Link>
                                      </td>
                                    ) : id2 == 0 && id3 == 1 ? (
                                      <td
                                        rowSpan={
                                          this.props.rowSpan.essid[essid] - 2
                                        }
                                        className="border-right align-middle text-center no-border-top"
                                        title={`View details for ${
                                          row.test || essid
                                        }`}
                                      >
                                        <Link
                                          to={
                                            "/" +
                                            row.probeid +
                                            "/active/" +
                                            row.cssid
                                          }
                                          target="_blank"
                                        >
                                          <div>
                                            <div>
                                              <strong>{essid}</strong>
                                            </div>
                                            <div className="sub-title">
                                              {row.name
                                                .replace(/\s+/g, " ")
                                                .trim() ==
                                              row.essid +
                                                " with test " +
                                                row.test
                                                ? row.test
                                                : row.name}
                                            </div>
                                          </div>
                                        </Link>
                                      </td>
                                    ) : k == this.props.rowSpan.essid[essid] ? (
                                      <td
                                        // rowSpan={this.props.rowSpan.essid[essid] - 1}
                                        className="border-right align-middle text-center no-border-top"
                                        title={`View details for ${
                                          row.test || essid
                                        }`}
                                      >
                                        <Link
                                          to={
                                            "/" +
                                            row.probeid +
                                            "/active/" +
                                            row.cssid
                                          }
                                          target="_blank"
                                        >
                                          <div>
                                            <div>
                                              <strong>{essid}</strong>
                                            </div>
                                            <div className="sub-title">
                                              {row.name
                                                .replace(/\s+/g, " ")
                                                .trim() ==
                                              row.essid +
                                                " with test " +
                                                row.test
                                                ? row.test
                                                : row.name}
                                            </div>
                                          </div>
                                        </Link>
                                      </td>
                                    ) : null}

                                    {/* dynamic */}

                                    {id3 == 0 ? (
                                      <td
                                        rowSpan={
                                          this.props.data[essid][probename]
                                            .length
                                        }
                                        className="border-right align-middle text-center"
                                        title={`View active measures for ${probename}`}
                                      >
                                        <Link
                                          to={"/" + row.probeid + "/active"}
                                          target="_blank"
                                        >
                                          <div>
                                            <strong> {probename} </strong>
                                            <div className="sub-title">
                                              {" "}
                                              {row.probeid
                                                .replace(/(..)/g, "$1:")
                                                .slice(0, -1)}{" "}
                                            </div>
                                          </div>
                                        </Link>
                                      </td>
                                    ) : null}
                                    <td
                                      className="border-right align-middle text-center"
                                      title={`View measure details for ${
                                        row.ap_name && row.ap_name != "-"
                                          ? row.ap_name
                                          : row.bssid
                                      }`}
                                    >
                                      <Link
                                        to={
                                          "/" +
                                          row.probeid +
                                          "/active/" +
                                          row.cssid +
                                          "/" +
                                          (row.bssid != "-"
                                            ? row.bssid.replace(/:/g, "")
                                            : "overal")
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <div>
                                          {row.ap_name != "-" &&
                                          row.ap_name != row.bssid ? (
                                            <div>
                                              <strong>{row.ap_name}</strong>
                                            </div>
                                          ) : (
                                            <div>
                                              <strong>{row.bssid}</strong>{" "}
                                            </div>
                                          )}
                                          {row.ap_name != "-" &&
                                          row.ap_name != row.bssid ? (
                                            <span className="sub-title">
                                              {row.bssid}{" "}
                                            </span>
                                          ) : row.manuf ? (
                                            <span className="sub-title">
                                              {row.manuf}{" "}
                                            </span>
                                          ) : null}
                                        </div>
                                      </Link>
                                    </td>
                                    <td
                                      className="border-right align-middle text-center"
                                      title={`View measure details for ${
                                        row.ap_name && row.ap_name != "-"
                                          ? row.ap_name
                                          : row.bssid
                                      }`}
                                    >
                                      <Link
                                        to={
                                          "/" +
                                          row.probeid +
                                          "/active/" +
                                          row.cssid +
                                          "/" +
                                          row.bssid.replace(/:/g, "")
                                        }
                                        target="_blank"
                                      >
                                        <div>
                                          <span
                                            className={
                                              row.last_state == "N" ||
                                              row.last_state == "U"
                                                ? "text-" +
                                                  this.getAppContext().conf
                                                    .MLY_STATES_DICTIONARY[
                                                    row.last_state
                                                  ].color
                                                : "text-" + row.color
                                            }
                                          >
                                            {
                                              this.getAppContext().conf
                                                .MLY_STATES_DICTIONARY[row.diag]
                                                .text
                                            }
                                          </span>
                                          {row.err_step ? (
                                            <div
                                              className={
                                                row.last_state == "N" ||
                                                row.last_state == "U"
                                                  ? "text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      row.last_state
                                                    ].color
                                                  : "text-" + row.color
                                              }
                                            >
                                              {row.err_step &&
                                              row.err_step.length > 0
                                                ? row.err_step.substring(
                                                    0,
                                                    2
                                                  ) == "MO"
                                                  ? "mostly on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                  : "on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                : null}
                                            </div>
                                          ) : null}
                                        </div>
                                      </Link>
                                    </td>
                                    <td
                                      className="border-right align-middle text-center"
                                      title={`View measure details for ${
                                        row.ap_name && row.ap_name != "-"
                                          ? row.ap_name
                                          : row.bssid
                                      }`}
                                    >
                                      <Link
                                        to={
                                          "/" +
                                          row.probeid +
                                          "/active/" +
                                          row.cssid +
                                          "/" +
                                          row.bssid.replace(/:/g, "")
                                        }
                                        target="_blank"
                                      >
                                        <div>
                                          {this.getAppContext()
                                            .momentjs(row.since, "X")
                                            .format("YYYY") < 2014 ? (
                                            "-"
                                          ) : (
                                            <div>
                                              <div>
                                                {this.getAppContext()
                                                  .momentjs(row.since, "X")
                                                  .format("DD-MM-YYYY")}
                                              </div>
                                              <div className="sub-title">
                                                {this.getAppContext()
                                                  .momentjs(row.since, "X")
                                                  .format("HH:mm")}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              }
                            );
                          }
                        );
                      }
                    )}
                  </tbody>
                )
              ) : null}

              {this.props.renderKey == "measureName" ? (
                this.getAppContext().media.isMobile ? (
                  <tbody>
                    {(() => {
                      let k = 0;
                      return Object.keys(this.props.data)
                        .sort()
                        .map((essid, id) => {
                          return Object.keys(this.props.data[essid]).map(
                            (probename, id2) => {
                              return this.props.data[essid][probename].map(
                                (row, id3) => {
                                  k += 1;
                                  return (
                                    <tr
                                      key={id3}
                                      className={
                                        k % 2 == 0
                                          ? "row-stripe-table p-2"
                                          : "p-2"
                                      }
                                    >
                                      <td>
                                        <div className="p-1">
                                          <div>
                                            {/* <div>
                                        <strong className="sub-title">ESSID: </strong>
                                      </div> */}
                                            <strong>{essid}</strong>
                                          </div>
                                          <div className="sub-title">
                                            {row.name
                                              .replace(/\s+/g, " ")
                                              .trim() ==
                                            row.essid + " with test " + row.test
                                              ? row.test
                                              : row.name}
                                          </div>
                                        </div>
                                        <div className="p-1">
                                          <div>
                                            <strong className="sub-title">
                                              PROBE:{" "}
                                            </strong>
                                          </div>
                                          <strong> {probename} </strong>
                                          <div className="sub-title">
                                            {" "}
                                            {row.probeid
                                              .replace(/(..)/g, "$1:")
                                              .slice(0, -1)}{" "}
                                          </div>
                                        </div>
                                        <div className="p-1">
                                          <div>
                                            <strong className="sub-title">
                                              AP:{" "}
                                            </strong>
                                          </div>
                                          {row.ap_name != "-" &&
                                          row.ap_name != row.bssid ? (
                                            <div>
                                              <strong>{row.ap_name}</strong>
                                            </div>
                                          ) : (
                                            <div>
                                              <strong>{row.bssid}</strong>{" "}
                                            </div>
                                          )}
                                          {row.ap_name != "-" &&
                                          row.ap_name != row.bssid ? (
                                            <span className="sub-title">
                                              {row.bssid}{" "}
                                            </span>
                                          ) : row.manuf ? (
                                            <span className="sub-title">
                                              {row.manuf}{" "}
                                            </span>
                                          ) : null}
                                        </div>

                                        <div className="p-1">
                                          <div>
                                            <strong className="sub-title">
                                              STATUS:{" "}
                                            </strong>
                                          </div>
                                          <span
                                            className={
                                              row.last_state == "N" ||
                                              row.last_state == "U"
                                                ? "text-" +
                                                  this.getAppContext().conf
                                                    .MLY_STATES_DICTIONARY[
                                                    row.last_state
                                                  ].color
                                                : "text-" + row.color
                                            }
                                          >
                                            {
                                              this.getAppContext().conf
                                                .MLY_STATES_DICTIONARY[row.diag]
                                                .text
                                            }
                                          </span>
                                          {row.err_step ? (
                                            <div
                                              className={
                                                row.last_state == "N" ||
                                                row.last_state == "U"
                                                  ? "text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      row.last_state
                                                    ].color
                                                  : "text-" + row.color
                                              }
                                            >
                                              {row.err_step &&
                                              row.err_step.length > 0
                                                ? row.err_step.substring(
                                                    0,
                                                    2
                                                  ) == "MO"
                                                  ? "mostly on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                  : "on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                : null}
                                            </div>
                                          ) : null}
                                        </div>
                                        {/* <div className="p-1">
                                    <div>
                                      <strong className="sub-title">SINCE: </strong>
                                    </div>
                                    {this.getAppContext()
                                      .momentjs(row.since, "X")
                                      .format("YYYY") < 2014 ? (
                                      "-"
                                    ) : (
                                      <div>
                                        <div>
                                          {this.getAppContext()
                                            .momentjs(row.since, "X")
                                            .format("DD-MM-YYYY")}
                                        </div>
                                        <div className="sub-title">
                                          {this.getAppContext()
                                            .momentjs(row.since, "X")
                                            .format("HH:mm")}
                                        </div>
                                      </div>
                                    )}
                                  </div> */}
                                      </td>
                                    </tr>
                                  );
                                }
                              );
                            }
                          );
                        });
                    })()}
                  </tbody>
                ) : (
                  <tbody>
                    {this.customSort(Object.keys(this.props.data)).map(
                      (measureName, id) => {
                        let k = 0;
                        return Object.keys(this.props.data[measureName]).map(
                          (probename, id2) => {
                            return this.props.data[measureName][probename].map(
                              (row, id3) => {
                                k += 1;
                                return (
                                  <tr
                                    key={id3}
                                    className={
                                      id % 2 != 0 ? "row-stripe-table" : ""
                                    }
                                  >
                                    {/* dynamic */}

                                    {this.props.rowSpan.measureName[
                                      measureName
                                    ] < 14 ? (
                                      id2 == 0 && id3 == 0 ? (
                                        <td
                                          rowSpan={
                                            this.props.rowSpan.measureName[
                                              measureName
                                            ]
                                          }
                                          className="border-right align-middle text-center"
                                          title={`View details for ${measureName}`}
                                        >
                                          <Link
                                            to={
                                              "/" +
                                              row.probeid +
                                              "/active/" +
                                              row.cssid +
                                              "/" +
                                              (row.bssid != "-"
                                                ? row.bssid.replace(/:/g, "")
                                                : "overal")
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <div>
                                              <strong>{measureName}</strong>
                                            </div>
                                          </Link>
                                        </td>
                                      ) : null
                                    ) : id2 == 0 && id3 == 0 ? (
                                      <td
                                        // rowSpan={this.props.rowSpan.essid[essid]}
                                        className="border-right align-middle text-center"
                                        title={`View details for ${measureName}`}
                                      >
                                        <div>
                                          <Link
                                            to={
                                              "/" +
                                              row.probeid +
                                              "/active/" +
                                              row.cssid +
                                              "/" +
                                              (row.bssid != "-"
                                                ? row.bssid.replace(/:/g, "")
                                                : "overal")
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <strong>{measureName}</strong>
                                          </Link>
                                        </div>
                                      </td>
                                    ) : id2 == 0 && id3 == 1 ? (
                                      <td
                                        rowSpan={
                                          this.props.rowSpan.measureName[
                                            measureName
                                          ] - 2
                                        }
                                        className="border-right align-middle text-center no-border-top"
                                        title={`View details for ${measureName}`}
                                      >
                                        <Link
                                          to={
                                            "/" +
                                            row.probeid +
                                            "/active/" +
                                            row.cssid +
                                            "/overal"
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <div>
                                            <strong>{measureName}</strong>
                                          </div>
                                        </Link>
                                      </td>
                                    ) : k ==
                                      this.props.rowSpan.measureName[
                                        measureName
                                      ] ? (
                                      <td
                                        // rowSpan={this.props.rowSpan.essid[essid] - 1}
                                        className="border-right align-middle text-center no-border-top"
                                        title={`View details for ${measureName}`}
                                      >
                                        <div>
                                          <Link
                                            to={
                                              "/" +
                                              row.probeid +
                                              "/active/" +
                                              row.cssid +
                                              "/" +
                                              (row.bssid != "-"
                                                ? row.bssid.replace(/:/g, "")
                                                : "overal")
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <strong>{measureName}</strong>
                                          </Link>
                                        </div>
                                      </td>
                                    ) : null}

                                    {/* dynamic */}

                                    {id3 == 0 ? (
                                      <td
                                        rowSpan={
                                          this.props.data[measureName][
                                            probename
                                          ].length
                                        }
                                        className="border-right align-middle text-center"
                                        title={`View active measures for ${probename}`}
                                      >
                                        <Link
                                          to={"/" + row.probeid + "/active"}
                                          target="_blank"
                                        >
                                          <div>
                                            <strong> {probename} </strong>
                                            <div className="sub-title">
                                              {" "}
                                              {row.probeid
                                                .replace(/(..)/g, "$1:")
                                                .slice(0, -1)}{" "}
                                            </div>
                                          </div>
                                        </Link>
                                      </td>
                                    ) : null}
                                    <td className="border-right align-middle text-center">
                                      <Link
                                        to={"/" + row.probeid + "/active/"}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <div>
                                          {row.label ? (
                                            <Link
                                              to={
                                                "/" + row.probeid + "/active/"
                                              }
                                              target="_blank"
                                            >
                                              <strong>{row.label}</strong>
                                            </Link>
                                          ) : (
                                            "-"
                                          )}
                                        </div>
                                      </Link>
                                    </td>
                                    <td className="border-right align-middle text-center">
                                      <Link
                                        to={
                                          "/" +
                                          row.probeid +
                                          "/active/" +
                                          row.cssid +
                                          "/overal"
                                        }
                                        target="_blank"
                                      >
                                        <div>
                                          <span
                                            className={
                                              row.last_state == "N" ||
                                              row.last_state == "U"
                                                ? "text-" +
                                                  this.getAppContext().conf
                                                    .MLY_STATES_DICTIONARY[
                                                    row.last_state
                                                  ].color
                                                : "text-" + row.color
                                            }
                                          >
                                            {
                                              this.getAppContext().conf
                                                .MLY_STATES_DICTIONARY[row.diag]
                                                .text
                                            }
                                          </span>
                                          {row.err_step ? (
                                            <div
                                              className={
                                                row.last_state == "N" ||
                                                row.last_state == "U"
                                                  ? "text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      row.last_state
                                                    ].color
                                                  : "text-" + row.color
                                              }
                                            >
                                              {row.err_step &&
                                              row.err_step.length > 0
                                                ? row.err_step.substring(
                                                    0,
                                                    2
                                                  ) == "MO"
                                                  ? "mostly on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                  : "on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                : null}
                                            </div>
                                          ) : null}
                                        </div>
                                      </Link>
                                    </td>
                                    <td className="border-right align-middle text-center">
                                      <Link
                                        to={
                                          "/" +
                                          row.probeid +
                                          "/active/" +
                                          row.cssid +
                                          "/overal"
                                        }
                                        target="_blank"
                                      >
                                        <div>
                                          {this.getAppContext()
                                            .momentjs(row.since, "X")
                                            .format("YYYY") < 2014 ? (
                                            "-"
                                          ) : (
                                            <div>
                                              <div>
                                                {this.getAppContext()
                                                  .momentjs(row.since, "X")
                                                  .format("DD-MM-YYYY")}
                                              </div>
                                              <div className="sub-title">
                                                {this.getAppContext()
                                                  .momentjs(row.since, "X")
                                                  .format("HH:mm")}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              }
                            );
                          }
                        );
                      }
                    )}
                  </tbody>
                )
              ) : null}

              {this.props.renderKey == "ap" ? (
                this.getAppContext().media.isMobile ? (
                  <tbody>
                    {(() => {
                      let k = 0;
                      return Object.keys(this.props.data)
                        .sort()
                        .map((ap, id) => {
                          return Object.keys(this.props.data[ap]).map(
                            (probename, id2) => {
                              return this.props.data[ap][probename].map(
                                (row, id3) => {
                                  k += 1;
                                  return (
                                    <tr
                                      key={id3}
                                      className={
                                        k % 2 == 0
                                          ? "row-stripe-table p-2"
                                          : "p-2"
                                      }
                                    >
                                      <td>
                                        <div className="p-1">
                                          {row.ap_name != "-" &&
                                          row.ap_name != row.bssid ? (
                                            <div>
                                              <strong>{row.ap_name}</strong>
                                            </div>
                                          ) : (
                                            <div>
                                              <strong>{row.bssid}</strong>{" "}
                                            </div>
                                          )}
                                          {row.ap_name != "-" &&
                                          row.ap_name != row.bssid ? (
                                            <span className="sub-title">
                                              {row.bssid}{" "}
                                            </span>
                                          ) : row.manuf ? (
                                            <span className="sub-title">
                                              {row.manuf}{" "}
                                            </span>
                                          ) : null}
                                        </div>
                                        <div className="p-1">
                                          <Link
                                            to={"/" + row.probeid + "/active"}
                                            target="_blank"
                                          >
                                            <div>
                                              <strong> {probename} </strong>
                                            </div>
                                            <div className="sub-title">
                                              {" "}
                                              {row.probeid
                                                .replace(/(..)/g, "$1:")
                                                .slice(0, -1)}{" "}
                                            </div>
                                          </Link>
                                        </div>
                                        <div className="p-1">
                                          <div>
                                            <strong className="sub-title">
                                              ESSID:{" "}
                                            </strong>
                                          </div>
                                          <div>
                                            <strong>{row.essid}</strong>
                                          </div>
                                          <div className="sub-title">
                                            {row.name
                                              .replace(/\s+/g, " ")
                                              .trim() ==
                                            row.essid + " with test " + row.test
                                              ? row.test
                                              : row.name}
                                          </div>
                                        </div>

                                        <div className="p-1">
                                          <Link
                                            to={
                                              "/" +
                                              row.probeid +
                                              "/active/" +
                                              row.cssid +
                                              "/" +
                                              row.bssid.replace(/:/g, "")
                                            }
                                            target="_blank"
                                          >
                                            <div>
                                              <strong className="sub-title">
                                                STATUS:{" "}
                                              </strong>
                                            </div>
                                            <span
                                              className={
                                                row.last_state == "N" ||
                                                row.last_state == "U"
                                                  ? "text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      row.last_state
                                                    ].color
                                                  : "text-" + row.color
                                              }
                                            >
                                              {
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY[
                                                  row.diag
                                                ].text
                                              }
                                            </span>
                                            {row.err_step ? (
                                              <div
                                                className={
                                                  row.last_state == "N" ||
                                                  row.last_state == "U"
                                                    ? "text-" +
                                                      this.getAppContext().conf
                                                        .MLY_STATES_DICTIONARY[
                                                        row.last_state
                                                      ].color
                                                    : "text-" + row.color
                                                }
                                              >
                                                {row.err_step &&
                                                row.err_step.length > 0
                                                  ? row.err_step.substring(
                                                      0,
                                                      2
                                                    ) == "MO"
                                                    ? "mostly on " +
                                                      row.err_step.substring(
                                                        3,
                                                        row.err_step.length
                                                      )
                                                    : "on " +
                                                      row.err_step.substring(
                                                        3,
                                                        row.err_step.length
                                                      )
                                                  : null}
                                              </div>
                                            ) : null}
                                          </Link>
                                        </div>
                                        {/* <div>
                              <div className="p-1">
                                <strong className="sub-title">SINCE: </strong>
                              </div>
                              {this.getAppContext()
                                .momentjs(row.since, "X")
                                .format("YYYY") < 2014 ? (
                                "-"
                              ) : (
                                <div>
                                  <div>
                                    {this.getAppContext()
                                      .momentjs(row.since, "X")
                                      .format("DD-MM-YYYY")}
                                  </div>
                                  <div className="sub-title">
                                    {this.getAppContext()
                                      .momentjs(row.since, "X")
                                      .format("HH:mm")}
                                  </div>
                                </div>
                              )}
                            </div> */}
                                      </td>
                                    </tr>
                                  );
                                }
                              );
                            }
                          );
                        });
                    })()}
                  </tbody>
                ) : (
                  <tbody>
                    {this.customSort(Object.keys(this.props.data)).map(
                      (ap, id) =>
                        Object.keys(this.props.data[ap]).map((probename, id2) =>
                          this.props.data[ap][probename].map((row, id3) => {
                            return (
                              <tr
                                key={id3}
                                className={
                                  id % 2 != 0 ? "row-stripe-table" : ""
                                }
                              >
                                {id2 == 0 && id3 == 0 ? (
                                  <td
                                    rowSpan={this.props.rowSpan.ap[ap]}
                                    className="border-right align-middle text-center"
                                    title={`View measure details for ${
                                      row.ap_name && row.ap_name != "-"
                                        ? row.ap_name
                                        : row.bssid
                                    }`}
                                  >
                                    <Link
                                      to={
                                        "/" +
                                        row.probeid +
                                        "/active/" +
                                        row.cssid +
                                        "/" +
                                        (row.bssid != "-"
                                          ? row.bssid.replace(/:/g, "")
                                          : "overal")
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <div>
                                        {row.ap_name != "-" &&
                                        row.ap_name != row.bssid ? (
                                          <div>
                                            <strong>{row.ap_name}</strong>
                                          </div>
                                        ) : (
                                          <div>
                                            <strong>{row.bssid}</strong>{" "}
                                          </div>
                                        )}
                                      </div>
                                    </Link>
                                  </td>
                                ) : null}
                                {id3 == 0 ? (
                                  <td
                                    rowSpan={
                                      this.props.data[ap][probename].length
                                    }
                                    className="border-right align-middle text-center"
                                    title={`View active measures for ${probename}`}
                                  >
                                    <Link
                                      to={"/" + row.probeid + "/active"}
                                      target="_blank"
                                    >
                                      <div>
                                        <strong> {probename} </strong>
                                        <div className="sub-title">
                                          {" "}
                                          {row.probeid
                                            .replace(/(..)/g, "$1:")
                                            .slice(0, -1)}{" "}
                                        </div>
                                      </div>
                                    </Link>
                                  </td>
                                ) : null}
                                <td
                                  className="border-right align-middle text-center"
                                  title={`View details for ${
                                    row.test || row.essid
                                  }`}
                                >
                                  <Link
                                    to={
                                      "/" + row.probeid + "/active/" + row.cssid
                                    }
                                    target="_blank"
                                  >
                                    <div>
                                      <div>
                                        <strong>{row.essid}</strong>
                                      </div>
                                      <span className="sub-title">
                                        {row.name.replace(/\s+/g, " ").trim() ==
                                        row.essid + " with test " + row.test
                                          ? row.test
                                          : row.name}
                                      </span>
                                    </div>
                                  </Link>
                                </td>
                                <td
                                  className="border-right align-middle text-center"
                                  title={`View measure details for ${
                                    row.ap_name && row.ap_name != "-"
                                      ? row.ap_name
                                      : row.bssid
                                  }`}
                                >
                                  <Link
                                    to={
                                      "/" +
                                      row.probeid +
                                      "/active/" +
                                      row.cssid +
                                      "/" +
                                      row.bssid.replace(/:/g, "")
                                    }
                                    target="_blank"
                                  >
                                    <div>
                                      <span
                                        className={
                                          row.last_state == "N" ||
                                          row.last_state == "U"
                                            ? "text-" +
                                              this.getAppContext().conf
                                                .MLY_STATES_DICTIONARY[
                                                row.last_state
                                              ].color
                                            : "text-" + row.color
                                        }
                                      >
                                        {
                                          this.getAppContext().conf
                                            .MLY_STATES_DICTIONARY[row.diag]
                                            .text
                                        }
                                      </span>
                                      {row.err_step ? (
                                        <div
                                          className={
                                            row.last_state == "N" ||
                                            row.last_state == "U"
                                              ? "sub-title text-" +
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY[
                                                  row.last_state
                                                ].color
                                              : "sub-title text-" + row.color
                                          }
                                        >
                                          {row.err_step &&
                                          row.err_step.length > 0
                                            ? row.err_step.substring(0, 2) ==
                                              "MO"
                                              ? "mostly on " +
                                                row.err_step.substring(
                                                  3,
                                                  row.err_step.length
                                                )
                                              : "on " +
                                                row.err_step.substring(
                                                  3,
                                                  row.err_step.length
                                                )
                                            : null}
                                        </div>
                                      ) : null}
                                    </div>
                                  </Link>
                                </td>
                                <td
                                  className="border-right align-middle text-center"
                                  title={`View measure details for ${
                                    row.ap_name && row.ap_name != "-"
                                      ? row.ap_name
                                      : row.bssid
                                  }`}
                                >
                                  <Link
                                    to={
                                      "/" +
                                      row.probeid +
                                      "/active/" +
                                      row.cssid +
                                      "/" +
                                      row.bssid.replace(/:/g, "")
                                    }
                                    target="_blank"
                                  >
                                    <div>
                                      {this.getAppContext()
                                        .momentjs(row.since, "X")
                                        .format("YYYY") < 2014 ? (
                                        "-"
                                      ) : (
                                        <div>
                                          <div>
                                            {this.getAppContext()
                                              .momentjs(row.since, "X")
                                              .format("DD-MM-YYYY")}
                                          </div>
                                          <div className="sub-title">
                                            {this.getAppContext()
                                              .momentjs(row.since, "X")
                                              .format("HH:mm")}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </Link>
                                </td>
                              </tr>
                            );
                          })
                        )
                    )}
                  </tbody>
                )
              ) : null}

              {this.props.renderKey == "label" ? (
                this.getAppContext().media.isMobile ? (
                  (() => {
                    let k = 0;
                    return Object.keys(this.props.data)
                      .sort()
                      .map((ap, id) => {
                        return Object.keys(this.props.data[ap]).map(
                          (probename, id2) => {
                            return this.props.data[ap][probename].map(
                              (row, id3) => {
                                k += 1;
                                return (
                                  <div
                                    key={id3}
                                    className={
                                      k % 2 == 0
                                        ? "row-stripe-table p-2"
                                        : "p-2"
                                    }
                                  >
                                    <div className="p-1">
                                      {row.ap_name != "-" &&
                                      row.ap_name != row.bssid ? (
                                        <div>
                                          <strong>{row.ap_name}</strong>
                                        </div>
                                      ) : (
                                        <div>
                                          <strong>{row.bssid}</strong>{" "}
                                        </div>
                                      )}
                                      {row.ap_name != "-" &&
                                      row.ap_name != row.bssid ? (
                                        <span className="sub-title">
                                          {row.bssid}{" "}
                                        </span>
                                      ) : row.manuf ? (
                                        <span className="sub-title">
                                          {row.manuf}{" "}
                                        </span>
                                      ) : null}
                                    </div>
                                    <div className="p-1">
                                      <div>
                                        <strong> {probename} </strong>
                                      </div>
                                      <div className="sub-title">
                                        {" "}
                                        {row.probeid
                                          .replace(/(..)/g, "$1:")
                                          .slice(0, -1)}{" "}
                                      </div>
                                    </div>
                                    <div className="p-1">
                                      <div>
                                        <strong className="sub-title">
                                          ESSID:{" "}
                                        </strong>
                                      </div>
                                      <div>
                                        <strong>{row.essid}</strong>
                                      </div>
                                      <div className="sub-title">
                                        {row.name.replace(/\s+/g, " ").trim() ==
                                        row.essid + " with test " + row.test
                                          ? row.test
                                          : row.name}
                                      </div>
                                    </div>

                                    <div className="p-1">
                                      <div>
                                        <strong className="sub-title">
                                          STATUS:{" "}
                                        </strong>
                                      </div>
                                      <span
                                        className={
                                          row.last_state == "N" ||
                                          row.last_state == "U"
                                            ? "text-" +
                                              this.getAppContext().conf
                                                .MLY_STATES_DICTIONARY[
                                                row.last_state
                                              ].color
                                            : "text-" + row.color
                                        }
                                      >
                                        {
                                          this.getAppContext().conf
                                            .MLY_STATES_DICTIONARY[row.diag]
                                            .text
                                        }
                                      </span>
                                      {row.err_step ? (
                                        <div
                                          className={
                                            row.last_state == "N" ||
                                            row.last_state == "U"
                                              ? "text-" +
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY[
                                                  row.last_state
                                                ].color
                                              : "text-" + row.color
                                          }
                                        >
                                          {row.err_step &&
                                          row.err_step.length > 0
                                            ? row.err_step.substring(0, 2) ==
                                              "MO"
                                              ? "mostly on " +
                                                row.err_step.substring(
                                                  3,
                                                  row.err_step.length
                                                )
                                              : "on " +
                                                row.err_step.substring(
                                                  3,
                                                  row.err_step.length
                                                )
                                            : null}
                                        </div>
                                      ) : null}
                                    </div>
                                    {/* <div>
                              <div className="p-1">
                                <strong className="sub-title">SINCE: </strong>
                              </div>
                              {this.getAppContext()
                                .momentjs(row.since, "X")
                                .format("YYYY") < 2014 ? (
                                "-"
                              ) : (
                                <div>
                                  <div>
                                    {this.getAppContext()
                                      .momentjs(row.since, "X")
                                      .format("DD-MM-YYYY")}
                                  </div>
                                  <div className="sub-title">
                                    {this.getAppContext()
                                      .momentjs(row.since, "X")
                                      .format("HH:mm")}
                                  </div>
                                </div>
                              )}
                            </div> */}
                                  </div>
                                );
                              }
                            );
                          }
                        );
                      });
                  })()
                ) : (
                  <tbody>
                    {this.customSort(Object.keys(this.props.data)).map(
                      (label, id) =>
                        Object.keys(this.props.data[label]).map(
                          (probename, id2) =>
                            this.props.data[label][probename].map(
                              (row, id3) => {
                                return (
                                  <tr
                                    key={id3}
                                    className={
                                      id % 2 != 0 ? "row-stripe-table" : ""
                                    }
                                  >
                                    {id2 == 0 && id3 == 0 ? (
                                      <td
                                        rowSpan={
                                          this.props.rowSpan.label[label]
                                        }
                                        className="border-right align-middle text-center"
                                        title={row.ap_name}
                                      >
                                        <div>
                                          {row.label ? (
                                            <Link
                                              to={
                                                "/" + row.probeid + "/active/"
                                              }
                                              target="_blank"
                                            >
                                              <strong>{row.label}</strong>{" "}
                                            </Link>
                                          ) : (
                                            "-"
                                          )}
                                        </div>
                                      </td>
                                    ) : null}
                                    {id3 == 0 ? (
                                      <td
                                        rowSpan={
                                          this.props.data[label][probename]
                                            .length
                                        }
                                        className="border-right align-middle text-center"
                                        title={probename}
                                      >
                                        <Link
                                          to={"/" + row.probeid + "/active"}
                                          target="_blank"
                                        >
                                          <div>
                                            <strong> {probename} </strong>
                                            <div className="sub-title">
                                              {" "}
                                              {row.probeid
                                                .replace(/(..)/g, "$1:")
                                                .slice(0, -1)}{" "}
                                            </div>
                                          </div>
                                        </Link>
                                      </td>
                                    ) : null}
                                    <td className="border-right align-middle text-center">
                                      <div>
                                        <Link
                                          to={
                                            "/" +
                                            row.probeid +
                                            "/active/" +
                                            row.cssid +
                                            "/" +
                                            (row.bssid != "-"
                                              ? row.bssid.replace(/:/g, "")
                                              : "overal")
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <strong>{row.name}</strong>
                                        </Link>
                                      </div>
                                    </td>
                                    <td className="border-right align-middle text-center">
                                      <Link
                                        to={
                                          "/" +
                                          row.probeid +
                                          "/active/" +
                                          row.cssid +
                                          "/overal"
                                        }
                                        target="_blank"
                                      >
                                        <div>
                                          <span
                                            className={
                                              row.last_state == "N" ||
                                              row.last_state == "U"
                                                ? "text-" +
                                                  this.getAppContext().conf
                                                    .MLY_STATES_DICTIONARY[
                                                    row.last_state
                                                  ].color
                                                : "text-" + row.color
                                            }
                                          >
                                            {
                                              this.getAppContext().conf
                                                .MLY_STATES_DICTIONARY[row.diag]
                                                .text
                                            }
                                          </span>
                                          {row.err_step ? (
                                            <div
                                              className={
                                                row.last_state == "N" ||
                                                row.last_state == "U"
                                                  ? "sub-title text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      row.last_state
                                                    ].color
                                                  : "sub-title text-" +
                                                    row.color
                                              }
                                            >
                                              {row.err_step &&
                                              row.err_step.length > 0
                                                ? row.err_step.substring(
                                                    0,
                                                    2
                                                  ) == "MO"
                                                  ? "mostly on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                  : "on " +
                                                    row.err_step.substring(
                                                      3,
                                                      row.err_step.length
                                                    )
                                                : null}
                                            </div>
                                          ) : null}
                                        </div>
                                      </Link>
                                    </td>
                                    <td className="border-right align-middle text-center">
                                      <Link
                                        to={
                                          "/" +
                                          row.probeid +
                                          "/active/" +
                                          row.cssid +
                                          "/overal"
                                        }
                                        target="_blank"
                                      >
                                        <div>
                                          {this.getAppContext()
                                            .momentjs(row.since, "X")
                                            .format("YYYY") < 2014 ? (
                                            "-"
                                          ) : (
                                            <div>
                                              <div>
                                                {this.getAppContext()
                                                  .momentjs(row.since, "X")
                                                  .format("DD-MM-YYYY")}
                                              </div>
                                              <div className="sub-title">
                                                {this.getAppContext()
                                                  .momentjs(row.since, "X")
                                                  .format("HH:mm")}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              }
                            )
                        )
                    )}
                  </tbody>
                )
              ) : null}
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default contextProvider(withRouter(RowSpanTableDiag), {
  define: null,
});
